import React, {useEffect, useState} from "react";
import { graphql } from "gatsby";
import { Col, Row } from "react-bootstrap";
import CustomTooltip from "../../atoms/CustomTooltip";
import "./regionalOverview.scss";
import CustomReactCountup from "../../atoms/CustomReactCountup";

export const ParagraphRegionalOverview = ({ node, tabData }) => {
  const [visited, setVisited] = useState(tabData === undefined); // set default as true if no tabs

  useEffect(() => {
    if(!visited && (Number(tabData?.current) === Number(tabData?.selected))){
      setVisited(true)
    }
  }, [tabData?.selected])

  const { field_cta, field_body_text, relationships } = node;
  const image =
    relationships?.field_card_image?.relationships?.field_media_image
      ?.publicUrl;

  return (
    <div className="featured-image-with-stats">
      {
        Boolean(image) && (
          <div className="featured-image-container">
            <img src={image} alt="globe" />
          </div>
        )
      }
      <div className="stats-container">
        <Row>
          {relationships?.field_statistic_report?.map((report) => (
            <Col md={6} sm={12}>
              <div className="stat-box first">
                {
                  Boolean(report?.field_figure) && visited && (
                    <h4 className="stat-title">
                      <CustomReactCountup redraw={!visited} end={report?.field_figure} suffix={report?.field_unit}/>
                    </h4>
                  )
                }
                {
                  Boolean(report?.field_figure_title) && (
                    <div className="stat-subtitle-wrapper">
                      <h5 className="stat-subtitle">
                        <span>{report?.field_figure_title}</span>
                        {Boolean(report?.field_tooltip_description) && (
                          <CustomTooltip content={report?.field_tooltip_description}>
                            <i className="icon-bulb" />
                          </CustomTooltip>
                        )}
                      </h5>
                    </div>
                  )
                }
                <Row>
                  <Col xl={7} lg={12} className="colored-stat-wrapper">
                    {
                      Boolean(report?.field_conflict_figure_number) && visited && (
                        <h4 className="stat-orange">
                          <CustomReactCountup
                            redraw={!visited}
                            end={report?.field_conflict_figure_number}
                            suffix={report?.field_conflict_unit}
                          />
                        </h4>
                      )
                    }
                    {
                      Boolean(report?.field_conflict_figure_title) && (
                        <p>{report?.field_conflict_figure_title}</p>
                      )
                    }
                  </Col>
                  <Col xl={5} lg={12} className="colored-stat-wrapper">
                    {
                      Boolean(report?.field_disaster_figure_number) && visited && (
                        <h4 className="stat-blue">
                          <CustomReactCountup
                            redraw={!visited}
                            end={report?.field_disaster_figure_number}
                            suffix={report?.field_disaster_unit}
                          />
                        </h4>
                      )
                    }
                    {
                      Boolean(report?.field_disaster_figure_title) && (
                        <p>{report?.field_disaster_figure_title}</p>
                      )
                    }
                  </Col>
                </Row>
              </div>
            </Col>
          ))}
        </Row>
        <Row className="stats-summary">
          <Col>
            {
              Boolean(field_body_text) && (
                <div className="stats-summary-content" dangerouslySetInnerHTML={{ __html: field_body_text?.value }}/>
              )
            }
            {Boolean(field_cta?.title) && (
              <a
                target="_blank"
                href={field_cta?.url}
                className="btn btn-white"
              >
                {field_cta?.title}
              </a>
            )}
          </Col>
        </Row>
      </div>
    </div>
  );
};

export const fragment = graphql`
  fragment ParagraphRegionalOverview on paragraph__regional_overview {
    relationships {
      field_card_image {
        relationships {
          field_media_image {
            publicUrl
          }
        }
      }
      field_statistic_report {
        field_conflict_figure_number
        field_conflict_figure_title
        field_conflict_unit
        field_disaster_figure_number
        field_disaster_figure_title
        field_disaster_unit
        field_figure
        field_figure_title
        field_tooltip_description
        field_unit
      }
    }
    field_cta {
      title
      url
    }
    field_body_text {
      value
    }
  }
`;
